import React, {useCallback, useContext, useEffect, useReducer, useRef, useState} from "react"
import {callAPI, useAPI} from "../../lib/common";
import TemplateList from "../../lib/templatelist";

export const ACTIONS = {
  SET_TEMPLATE: 'set-template',
  SET_RESOURCES: 'set-resources',
  FILL_TEMPLATE: 'fill-template',
  SET_PRODUCT: 'set-product',
  PREVIOUS_PARTREF: 'previous-partref',
  NEXT_PARTREF: 'next-partref',
  SET_YEAR: 'set-year',
  SET_CURRENT_RESOURCE: 'set-current-resource',
  SET_CURRENT_IMAGE_CROP_RECT: 'set-current-image-crop-rect',
  CHANGE_CURRENT_IMAGE: 'change-current-image',
  UPDATE_CURRENT_IMAGE: 'update-current-image',
  CHANGE_CURRENT_IMAGE_EFFECT: 'change-current-image-filter',
  CHANGE_CURRENT_IMAGE_ROTATION: 'change-current-image-rotation',
  CHANGE_CURRENT_TEXT: 'change-current-text',
  CHANGE_CURRENT_TEXT_ALIGN: 'change-current-text-align',
  CHANGE_CURRENT_TEXT_SIZE: 'change-current-text-size',
  CHANGE_CURRENT_TEXT_FAMILY: 'change-current-text-family',
  CHANGE_CURRENT_TEXT_COLOR: 'change-current-text-color',
  UPDATE_CURRENT_TEXT: 'update-current-text',
  SET_CURRENT_PARTREF: 'set-current-partref',
  SET_SCALE_RATIO: 'set-scale-ratio'
}

export const TemplateInstanceContext = React.createContext('Template Instance');


const updateCurrentText = (state, what, value) => {
  if (!state.currentPartRefId) {
    return state;
  }
  const partRef = getPartRefById(state.currentPartRefId, state.template);
  const resource = getResource(partRef, state.currentResourceId, state);
  const resources = {...state.resources, [resource.fullId]: {
      ...resource,
      font: {
        ...resource.font,
        [what]: value
      }}}
  return {...state,  resources}
}

const updateCurrentImage = (state, what, value) => {
  if (!state.currentPartRefId) {
    return state;
  }
  const partRef = getPartRefById(state.currentPartRefId, state.template);
  const resource = getResource(partRef, state.currentResourceId, state);
  const resources = {...state.resources, [resource.fullId]: {
      ...resource,
      image: {
        ...resource.image,
        [what]: value
      }}}
  return {...state,  resources}
}


const templateInstanceReducer = (state, action) => {
  let partRef, resource, resources;

  switch (action.type) {
    case ACTIONS.SET_SCALE_RATIO:
      return {
        ...state,
        scaleRatio: action.scaleRatio
      }
    case ACTIONS.SET_TEMPLATE:
      return createInstance(action.template);
    case ACTIONS.SET_RESOURCES:
      return {
        ...state,
        resources: {
          ...state.resources,
          ...action.resources
        }
      };
    case ACTIONS.SET_PRODUCT:
      return {
        ...state,
        product: action.product
      }
    case ACTIONS.FILL_TEMPLATE:
      const filledResources = fillResources(state.resources, state.template, action.userImages, action.userStrings)
      return {...state, resources: filledResources}
    case ACTIONS.SET_CURRENT_PARTREF:
      return {
        ...state,
        currentPartRefId: action.partRefId
      }
    case ACTIONS.SET_CURRENT_RESOURCE:
      return {...state, currentResourceId: action.id }
    case ACTIONS.UPDATE_CURRENT_TEXT:
      if (!state.currentPartRefId) {
        return state;
      }
      partRef = getPartRefById(state.currentPartRefId, state.template);
      resource = getResource(partRef, state.currentResourceId, state);
      resources = {...state.resources, [resource.fullId]: {
          ...resource,
          font: {
            ...resource.font,
            ...action.font
          }
        }
      }
      return {
        ...state,
        dirty: true,
        resources}
    case ACTIONS.UPDATE_CURRENT_IMAGE:
      if (!state.currentPartRefId) {
        return state;
      }
      partRef = getPartRefById(state.currentPartRefId, state.template);
      resource = getResource(partRef, state.currentResourceId, state);
      resources = {...state.resources, [resource.fullId]: {
          ...resource,
          image: action.image
        }
      }
      return {
        ...state,
        dirty: true,
        resources
      }
    case ACTIONS.PREVIOUS_PARTREF:
      let partRefIds = getPartRefIds(state.template);
      let currentPartRefIndex = partRefIds.indexOf(state.currentPartRefId);
      if (currentPartRefIndex > 0) {
        currentPartRefIndex--;
      }
      return {...state,
        currentPartRefId: partRefIds[currentPartRefIndex],
        currentResourceId:  null
      }
    case ACTIONS.NEXT_PARTREF:
      partRefIds = getPartRefIds(state.template);
      currentPartRefIndex = partRefIds.indexOf(state.currentPartRefId);
      if (currentPartRefIndex < partRefIds.length - 1) {
        currentPartRefIndex++;
      }
      return {...state,
        currentPartRefId: partRefIds[currentPartRefIndex],
        currentResourceId:  null
      }
    case ACTIONS.SET_YEAR:
      return {...state, year: action.year}
    /*
    case ACTIONS.CHANGE_CURRENT_TEXT_FAMILY:
      return updateCurrentText(state, 'family', action.family);
    case ACTIONS.CHANGE_CURRENT_TEXT_SIZE:
      return updateCurrentText(state, 'size', action.size);
    case ACTIONS.CHANGE_CURRENT_TEXT:
      return updateCurrentText(state, 'text', action.text);
    case ACTIONS.CHANGE_CURRENT_TEXT_ALIGN:
      return updateCurrentText(state, 'horizontalAlign', action.align);
    case ACTIONS.CHANGE_CURRENT_TEXT_COLOR:
      return updateCurrentText(state, 'color', action.color);

    case ACTIONS.CHANGE_CURRENT_IMAGE:
      return updateCurrentImage(state, 'uuid', action.image.uuid);
    case ACTIONS.CHANGE_CURRENT_IMAGE_EFFECT:
      return updateCurrentImage(state, 'overrideEffect', action.effect);
    case ACTIONS.SET_CURRENT_IMAGE_CROP_RECT:
      return updateCurrentImage(state, 'cropRect', action.cropRect);
    case ACTIONS.CHANGE_CURRENT_IMAGE_ROTATION:
      return updateCurrentImage(state, 'rotation', action.rotation);

     */
  }
  console.log('Unknown action', action);
  return state;
}


function fillImageResource(resource, template, userImages) {
  if (userImages.length == 0) {
    return resource;
  }

  const renderPart = getFirstRenderPartByResource(resource, template);
  if (!renderPart) {
    return resource;
  }

  let foundImage = null;
  let backupImage = null;
  const orientation = renderPart.size.width > renderPart.size.height ? 'landscape' : 'width';
  for (const image of userImages) {
    console.log('The image', image, userImages);;
    const imageOrientation = image.width > image.height ? 'landscape' : 'portrait';
    if (orientation == imageOrientation) {
      foundImage = image;
      break;
    }
    if (!backupImage) {
      backupImage = image;
    }
  }

  if (!foundImage && backupImage) {
    foundImage = backupImage;
  }

  if (foundImage) {
    return {...resource,
      image: {
        ...resource.image,
        ...foundImage
      }};
  }
}

export function fillResources(resources, template, userImages, userStrings) {
  for (const key of Object.keys(resources)) {
    console.log('User images', resources, userImages);
    const resource = resources[key];
    if (!resource.userSupplied) {
      continue;
    }

    if (resource.type == 'IMAGE') {
      resources[key] = fillImageResource(resource, template, userImages)
      // Rotate the array to get "random" images:
      if (userImages.length > 0) {
        const firstImage = userImages.shift();
        userImages.push(firstImage);
      }
    }
    else {
      resources[key] = resource;
    }
  }
  return resources;
}

export function getCurrentResource(state) {
  if (!state.currentResourceId) {
    return null;
  }
  const partRef = getPartRefById(state.currentPartRefId, state.template);
  const resources = getUserResourcesByPartRef(partRef, state);

  for (const resource of resources) {
    if (resource.fullId == state.currentResourceId) {
      return resource;
    }
  }
  return null;
}

export function getUserResourcesByPartRef(partRef, template) {
  const templateData = getDataByPartRef(partRef, template)
  const cache = {};
  let key = null;
  let resource = null;
  const resources = [];

  for (const renderPart of templateData.renderParts) {
    key = templateData.partRef.id + '#' + renderPart.resourceId;
    if (cache[key]) {
      continue;
    }
    resource = getResource(templateData.partRef, renderPart.resourceId, template)

    // Might be month, monthstring or similar?
    if (!resource) {
      continue;
    }
    console.log('The resource', resource, renderPart);
    if (resource.userSupplied) {
      resources.push(resource);
    }
    cache[key] = true;
  }
  return resources;
}

function getUserResourcesByPartRefAndType(partRef, template, type) {
  const resources = getUserResourcesByPartRef(partRef, template);

  console.log('Found resources', resources, type)

  return resources.filter(resource => resource.type == type)
}

export function getUserTextResourcesByPartRef(partRef, template) {
  return getUserResourcesByPartRefAndType(partRef, template, 'STRING');
}

export function getUserImageResourcesByPartRef(partRef, template) {
  return getUserResourcesByPartRefAndType(partRef, template, 'IMAGE');
}

export function getUserImageResources(state) {
  return Object.values(state.resources)
      .filter((resource) => {
        return (resource.type == 'IMAGE' && resource.userSupplied);
      })
}

export function getImageResourceSize(image, renderPart) {
  let size = {width: image.width, height: image.height};

  if (image.rotation == 90 || image.rotation == 270) {
    size = { width: image.height, height: image.width};
  }

  if (renderPart.image.rotation == 90 || renderPart.image.rotation == 270) {
    size = {width: image.height, height: image.width};
  }
  return size;
}

export function getFirstRenderPartByResource(resource, template) {
  for (const partRef of template.partRefs) {
    if (partRef.clientIgnore) {
      continue;
    }
    const partType = getPartTypeById(partRef.typeId, template);
    for (const renderPart of partType.renderParts) {
      const resourceId = partRef.id + '#' + renderPart.resourceId;
      // Check local and global resources:
      if (resourceId == resource.fullId || renderPart.resourceId == resource.fullId) {
        return renderPart;
      }
    }
  }
}

export function getUserResourcesAsList(templateInstance) {
  return Object.values(templateInstance.resources)
    .filter(r => r.userSupplied)
    .map(r => ({
        fullId: r.fullId,
        type: r.type,
        image: r.image
    }));
}

export function getTemplateTranslation(texts, lang) {
  lang = lang.replace("_", "-");
  const lang2 = lang.replace("-", "_");
  if (texts[lang]) {
    return texts[lang];
  }
  if (texts[lang2]) {
    return texts[lang2];
  }
  if (texts[""]) {
    return texts[""];
  }
  if (texts["DEFAULT"]) {
    return texts["DEFAULT"];
  }
  return "";
}

export function getPartRefs(template) {
  return template.partRefs.filter(partRef => !partRef.clientIgnore);
}

export function getPartRefIds(template) {
  console.log('Getting part ref ids', template);
  const partRefIds = template.partRefs.filter(partRef => !partRef.clientIgnore).map(partRef => partRef.id);
  return partRefIds;
}

export function getResource(partRef, resourceId, templateInstance) {
  if (templateInstance.resources[partRef.id + '#' + resourceId]) {
    console.log('Found it!', partRef.id + '#' + resourceId);
    return templateInstance.resources[partRef.id + '#' + resourceId]
  }
  // Global resource:
  else if (templateInstance.resources[resourceId]) {
    return templateInstance.resources[resourceId]
  } else {
    return null;
  }
}

export function getPartTypeById(id, template) {
  for (const partType of template.partTypes) {
    if (partType.id === id) {
      return partType;
    }
  }
  return null;
}

export function resourceIsComplete(resource) {
  if (!resource.userSupplied) {
   return true;
  }
  if (!resource.required) {
    return true;
  }
  if (resource.type == 'STRING' && !resource.font.text) {
    return false;
  }
  if (resource.type == 'IMAGE' && !resource.image.uuid) {
    return false;
  }
  return true;
}

export function templateIsComplete(state) {
    for (const resource of Object.values(state.resources)) {
      if (!resourceIsComplete(resource)) {
        return false;
      }
    }
    return true;
}

function getUserResources(template) {
  const resources = {};
  for (const resource of template.resources) {
    resources[resource.id] = {...resource};
  }

  for (const partRef of template.partRefs.filter(partRef => !partRef.clientIgnore)) {
    const partType = getPartTypeById(partRef.typeId, template);
    for (const originalResource of partType.resources) {
      const resource = {...originalResource};
      resource.fullId = partRef.id + '#' + resource.id;
      resources[resource.fullId] = resource;
    }
  }
  return resources;
}

export function getPartRefById(id, template) {
  return template.partRefs.find(partRef => partRef.id == id);
}

export function partRefIdIsFirstPartRef(id, template) {
    const partRefIds = getPartRefIds(template);
    return partRefIds.indexOf(id)+1 == 1;
}

export function partRefIdIsLastPartRef(id, template) {
  const partRefIds = template.partRefs.filter(partRef => !partRef.clientIgnore).map(partRef => partRef.id);
  return partRefIds.indexOf(id) == partRefIds.length -1;
}

export function getDataByPartRef(partRef, templateInstance) {
  const partType = getPartTypeById(partRef.typeId, templateInstance.template);

  const renderParts = partType.renderParts.map((renderPart) => {
    const resource = getResource(partRef, renderPart.resourceId, templateInstance)
    return renderPart;
  });

  return {
    dimensions: templateInstance.template.dimensions,
    renderParts,
    partRef
  }
}

const getInitialYear = (template) => {
  if (template.supportedYears && template.supportedYears.length == 1) {
    return template.supportedYears[0];
  }

  const d = new Date();
  let currentYear = d.getFullYear();
  if (d.getMonth() > 5) {
    currentYear++;
  }
  return currentYear;
}

export function createInstance(template) {
  return {
    template,
    year: getInitialYear(template),
    resources: getUserResources(template),
    currentPartRefId: getPartRefIds(template)[0],
    currentResourceId: null,
  }
}


export default ({children, template, userImages}) => {
  const [state, dispatch] = useReducer(templateInstanceReducer, {template: null});

  return (<TemplateInstanceContext.Provider value={[state, dispatch]}>
      {children}
    </TemplateInstanceContext.Provider>
  );
}